import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';

import LoadingSpinner from 'components/LoadingSpinner';
import { logPageLoadFailure } from './page-load-diagnostics';

const LoadableFallback = ({ error, retry, timedOut }) => {
  const retryCountRef = useRef(0);

  useEffect(() => {
    if (error || timedOut) {
      logPageLoadFailure(error, { timedOut, retryCount: retryCountRef.current });
    }
  }, [error, timedOut]);

  const handleRetry = () => {
    retryCountRef.current += 1;
    // eslint-disable-next-line no-console
    console.info('[Dashboard] Retrying page bundle', {
      pathname: window.location.pathname,
      retryCount: retryCountRef.current,
      chunkRequest: error?.request,
    });
    retry();
  };

  if (error || timedOut) {
    return (
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
          height: 'calc(100vh - 130px)',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Typography sx={{ color: '#2f2f2f' }} variant="body1">
          Unable to load this page.
        </Typography>
        <Button onClick={handleRetry} type="button" variant="contained">
          Retry
        </Button>
      </Box>
    );
  }

  return <LoadingSpinner />;
};

LoadableFallback.propTypes = {
  error: PropTypes.any,
  retry: PropTypes.func,
  timedOut: PropTypes.bool,
};

export default LoadableFallback;
